
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preferences",
      function () {
        return require("private-next-pages/preferences.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preferences"])
      });
    }
  